<template>
  <div class="px-5 mt-9">
    <div v-if="error" class="error">Could not fetch the data</div>
    <!-- <SideBar /> -->
    <div v-if="documents" class="layout">
      <PostViewDate :posts="documents" />
      <TagPost :posts="documents" />
    </div>

    <div v-else>
      <Spinner />
    </div>
  </div>
</template>

<script>
import PostViewDate from "@/components/post/PostViewDate.vue"
import getCollection from "@/composables/getCollection"
import Spinner from "@/components/Spinner.vue"
import TagPost from "@/components/post/TagPost.vue"

export default {
  name: "Posts",
  components: { PostViewDate, Spinner, TagPost },
  setup() {
    const { error, documents } = getCollection("posts")

    return { error, documents }
  },
}
</script>
<style scoped></style>
